<template>
  <div class="Editoren">
  <div class="d-none d-sm-block">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Übersicht</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">AGB</li>
      </ol>
    </nav>
  </div>
    <h2>AGB</h2>

    <div v-if="loading" class="d-flex justify-content-center mb-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <p v-if="agb" v-html="markedValue"></p>

    <b-alert variant="success" :show="zugestimmt">Sie haben den AGB zustimmt!</b-alert>
    <b-alert variant="danger" :show="!zugestimmt">Sie müssen noch den aktuellen AGB zustimmen!<b-button size="sm" @click="acceptAGB" variant="primary" class="float-right">Jetzt zustimmen</b-button></b-alert>
  </div>
</template>

<script>
import api from '@/api/basic'
import userApi from '@/api/benutzer'
import marked from 'marked'
export default {
  name: 'AGB',
  methods: {
    async acceptAGB () {
      this.loading = true
      await userApi.acceptAGB()
      this.agb = await api.agb()
      this.loading = false
    },
    async update () {
      this.loading = true
      this.agb = await api.agb()
      this.loading = false
    }
  },
  computed: {
    markedValue () {
      let value = this.agb.value !== null ? this.agb.value : ''
      return marked(value)
    },
    zugestimmt () {
      return (this.agb !== null) ? this.agb.agbAccepted < 0 : false
    }
  },
  data () {
    return {
      localUser: this.$store.state.auth.user,
      agb: null,
      loading: false
    }
  },
  mounted () {
    this.update()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/AGB.vue